import { FieldValues, useController, UseControllerProps } from 'react-hook-form'

import ErrorMessage from '@/components/formik/messages/ErrorMessage'

import TextInput, { TextInputProps } from './TextInput'

type TextInputControllerProps<T extends FieldValues> = UseControllerProps<T> & Omit<TextInputProps, 'onBlur' | 'onChange' | 'value'>

export default function TextInputController<T extends FieldValues>(props: TextInputControllerProps<T>) {
  const { control, helperText, name, rules, InputProps, ...rest } = props
  const {
    field,
    fieldState: { error },
  } = useController({ name, control, rules })

  return (
    <TextInput
      {...rest}
      error={!!error}
      helperText={helperText ? helperText : error?.message ? <ErrorMessage error={error.message} /> : undefined}
      inputRef={field.ref} // send input ref, so we can focus on input when error appear
      InputProps={{
        onBlur: field.onBlur, // notify when input is touched/blur
        ...InputProps,
      }}
      name={field.name} // send down the input name
      onChange={field.onChange} // send value to hook form
      value={field.value} // input value
    />
  )
}
